import React from 'react'
import css from '../Modulecss/Home.module.css'
import { Link } from 'react-router-dom'
import Header from '../Components/Header'

export default function RunningCard ({ runnig, winnAmount, game_type  }) {
  const user = localStorage.getItem("userId");
  // console.log(user,"running")
  return (
    <>
   
      <div
        className={`${css.betCard} mt-1 battle_card_main card_bottom_border`}
      >
        <div className='d-flex'>
          <span
            className={`${css.betCardTitle} pl-3 d-flex align-items-center headings`}
          >
            Playing For
            <span className='ml-2'>
               <img style={{position:'absolute', top:'15px', width:"4%"}} src="/images/global.png"/>
            </span>
            <span className='ml-4'> {runnig.Game_Ammount}</span>
          </span>
          {(user == runnig.Accepetd_By._id ||
            user == runnig.Created_by._id) && (
            <Link
              className={`${css.bgSecondary} ${css.playButton} ${
                css.cxy
              } position-relative m-2 mx-1 ${
                runnig.Status == 'conflict' ? 'bg-danger' : 'bg-success'
              }`}
              style={{
                right: '0px',
                top: '-6px',
                padding: '10px 17px'
              }}
              to={{
                pathname: `/viewgame1/${runnig._id}`,
                state: { prevPath: window.location.pathname }
              }}
            >
              view
            </Link>
          )}
          <div
            className={`${css.betCardTitle} d-flex align-items-center headings`}
          >
            <span className='ml-auto mr-3' style={{textAlign:'end'}}>
              Prize
             <span className='ml-2'>
              <img style={{width:"11.9%" ,marginRight:'5px'}}  src="/images/global.png"/>
             </span>
              {runnig.Game_Ammount + winnAmount(runnig.Game_Ammount)}
            </span>
          </div>
        </div>
        <div className='py-1 row battle_card_inner_bottom'>
          <div className='pr-3 text-center col-5'>
          <img className='bet_img'  src="/images/avatars/Avatar1.png"/>
            <div style={{ lineHeight: 1 }}>

              <span className={css.betCard_playerName}>
                {runnig.Created_by.Name}
              </span>
            </div>
          </div>
          <div className='pr-3 text-center col-2 cxy'>
            <div className='vers-box'>
              <img
                src={process.env.PUBLIC_URL + '/images/Homepage/versers-2.png'}
                alt=''
                width='30px'
              />
            </div>
          </div>
          <div className='text-center col-5'>
          <img className='bet_img'  src="/images/avatars/Avatar2.png"/>
            <div style={{ lineHeight: 1 }}>
              <span className={css.betCard_playerName}>
                {runnig.Accepetd_By.Name}
              </span>
            </div>
          </div>
        </div>
      </div>
     
    </>
  )
}
